import Vue from 'vue'
import Router from 'vue-router'
import Login from "@/view/base/login/index"
import Unrespond from "@/view/base/404/index"
import Mobile from "@/view/mobile/index"
import MobilePaySuccess from "@/view/mobile/mobile-pay-success.vue"
import LogisticsInfo from "@/view/mobile/logistics-info.vue"
import Share from "@/view/share/index"
import ShareDownload from "@/view/share/download"
import Unshare from "@/view/unshare/index"
import riskAssessment from "@/view/riskAssessment/index"
import BI from "@/view/bi/index"
import BIAPP from "@/view/biApp/index"

Vue.use(Router)

export const constantRouterMap = [
    {
        path: '/',
        name: 'share',
        component: Share
    },
    {
        path: '/unshare/',
        name: 'unshare',
        component: Unshare
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/404',
        name: '404',
        component: Unrespond
    },
    {
        path: '/mobile',
        name: 'mobile',
        component: Mobile
    },
    {
        path: '/mobile/pay/success',
        name: 'mobilePaySuccess',
        component: MobilePaySuccess
    },
    {
        path: '/mobile/logistics/info',
        name: 'LogisticsInfo',
        component: LogisticsInfo
    },
    {
        path: '/share/download',
        name: 'shareDownload',
        component: ShareDownload
    },
    {
        path: '/riskAssessment',
        name: 'riskAssessment',
        component: riskAssessment
    },
    {
        path: '/bi/index',
        name: 'BI',
        component: BI,
    },
    {
        path: '/biApp/index',
        name: 'BIAPP',
        component: BIAPP,
    },
]

export default new Router({
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js